<template>
	<div class="binding-body">
		<div class="cusApro-add-search">
			<div class="search-box">
				<!-- <div class="input-box">
					<span>销售门店：</span>
					<el-select v-model="shopid" class="name-input" size='mini'>
						<el-option v-for="(item,index) in shopList" :key='index' :value="item.id" :label="item.name"></el-option>
					</el-select>
				</div> -->
				<div class="input-box">
					<span>商品名称：</span>
					<el-input
						v-model="productName"
						placeholder="请输入商品名称"
						class="name-input"
						size="mini"
						@keyup.enter.native="search"
					></el-input>
				</div>
				<div class="input-box">
					<span>SPU编号：</span>
					<el-input
						v-model="pcode"
						placeholder="请输入SPU编号"
						class="name-input"
			@keyup.enter.native="search"
						size="mini"
					></el-input>
				</div>
				<div class="input-box">
					<span>三方编号：</span>
					<el-input
						v-model="matchcode"
						placeholder="请输入三方编号"
						class="name-input"
			@keyup.enter.native="search"
						size="mini"
					></el-input>
				</div>
				<div class="input-box">
					<span>店铺级大类：</span>
					<el-select v-model="bcId" class="name-input" style="width: 150px;" size='small' @change="bcChange">
						<el-option value="0" label="全部"></el-option>
						<template v-for="(item) in bc">
							<el-option :value="item.bc_id" :label="item.bc_name" :key="item.bc_id"/>
						</template>
					</el-select>
				</div>
				<div class="input-box" v-if="bigcategoryview === 1">
					<span>店铺级小类：</span>
					<el-select v-model="scId" class="name-input" style="width: 150px;" size='small'>
						<el-option value="0" label="全部"></el-option>
						<template v-for="(item) in sc">
							<el-option :value="item.id" :label="item.name" :key="item.id"></el-option>
						</template>
					</el-select>
				</div>
				<div class="input-box">
					<span>私密状态：</span>
					<el-select v-model="privateproductFlag" class="name-input" placeholder="请选择私密状态" style="width: 150px;" size='small'>
						<el-option :value="-1" label="全部"></el-option>
						<el-option :value="0" label="公开"></el-option>
						<el-option :value="1" label="私密"></el-option>
					</el-select>
				</div>
				<div class="input-box">
					<span>销售门店：</span>
					<el-select
						size="small"
						class="name-input"
						v-model="shopIds"
						filterable
						multiple
						collapse-tags
						placeholder="请选择门店名称">
						<template v-for="item in shopNameList">
							<el-option
								:key="item.id"
								:label="item.name"
								:value="item.id">
							</el-option>
						</template>
					</el-select>
				</div>
				<div class="input-box">
					<span>启用状态：</span>
					<el-select v-model="disabledflag" class="name-input" placeholder="请选择启用状态" style="width: 150px;" size='small'>
						<el-option :value="-1" label="全部"></el-option>
						<el-option :value="0" label="启用"></el-option>
						<el-option :value="1" label="停用"></el-option>
					</el-select>
				</div>
			</div>
			<div class="input-box-btn">
				<el-button
					type="primary"
					class="search-btn"
					size="mini"
					@click="search">查询</el-button>
				<el-button
					class="search-btn"
					size="mini"
					plain
					@click="clear">清空</el-button>
			</div>
		</div>
		<div v-if="productQueryType === 0" style="text-align:left;height:40px;line-height:40px">
			<el-radio v-model="privateproductflag" :label="1">全部私密商品</el-radio>
			<el-radio v-model="privateproductflag" :label="0">指定私密商品</el-radio>
		</div>
        <div v-if="privateproductflag === 0 || productQueryType === 1" class="table-container">
			<div class="table-box">
				<div class="select-title">请选择商品</div>
				<el-table
					:stripe='true'
					class="grid-content"
					:data="tableData"
					size='mini'
					:height="tableHeight"
					border
					ref="multipleTable"
					@select="handleSelectionChange"
					@select-all="handleSelectionChange">
					<el-table-column
						fixed='left'
						type="selection"
						align="center"
						width="55"
						:selectable="selectInit">
					</el-table-column>
					<el-table-column
						prop="productname"
						label="商品名称"
						align="center"
						min-width="180">
						<template slot-scope="scope">
							<div style="white-space: pre-wrap">{{scope.row.productname}}</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="productCode"
						label="SPU编号"
						align="center"
						min-width="180">
					</el-table-column>
					<el-table-column
						prop="matchCode"
						label="三方编号"
						align="center"
						min-width="180">
					</el-table-column>
					<el-table-column
						prop="hiddenFlag"
						label="私密状态"
						align="center"
						min-width="100">
						<template slot-scope="scope">
							<span v-if="!scope.row.hiddenflag">公开</span>
							<span v-else>私密</span>
						</template>
					</el-table-column>
					<el-table-column
						prop="shopname"
						label="销售门店"
						align="center"
						min-width="180">
					</el-table-column>
					<el-table-column
						prop="bigcategory"
						label="店铺级大类"
						align="center"
						min-width="180">
					</el-table-column>
					<el-table-column
						prop="smallcategory"
						v-if="bigcategoryview === 1"
						label="店铺级小类"
						align="center"
						min-width="180">
					</el-table-column>
					<el-table-column
						prop="disabledflag"
						label="启用状态"
						align="center"
						min-width="100">
						<template slot-scope="scope">
							<span v-if="scope.row.disabledflag">停用</span>
							<span v-else>启用</span>
						</template>
					</el-table-column>
				</el-table>
				<div class="page-box">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:current-page="page.number"
						:page-sizes="[20, 40, 60, 100, 300]"
						:page-size="page.size"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total">
					</el-pagination>
				</div>
			</div>
			<div style="margin-left: 20px;" class="table-box">
				<div class="select-title">已选择商品：{{this.ids.length}}</div>
				<el-table
					:stripe='true'
					class="grid-content"
					:data="ids"
					size='mini'
					:height="tableHeight"
					border
					ref="multipleTable1"
					@select="handleSelectionChange1"
					@select-all="handleSelectionChange1">
					<el-table-column
						fixed='left'
						type="selection"
						align="center"
						width="55">
					</el-table-column>
					<el-table-column
						prop="productname"
						label="商品名称"
						align="center"
						min-width="180">
						<template slot-scope="scope">
							<div style="white-space: pre-wrap">{{scope.row.productname}}</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="productCode"
						label="SPU编号"
						align="center"
						min-width="180">
					</el-table-column>
					<el-table-column
						prop="matchCode"
						label="三方编号"
						align="center"
						min-width="180">
					</el-table-column>
					<el-table-column
						prop="hiddenFlag"
						label="私密状态"
						align="center"
						min-width="100">
						<template slot-scope="scope">
							<span v-if="!scope.row.hiddenflag">公开</span>
							<span v-else>私密</span>
						</template>
					</el-table-column>
					<el-table-column
						prop="shopname"
						label="销售门店"
						align="center"
						min-width="180">
					</el-table-column>
					<el-table-column
						prop="bigcategory"
						label="店铺级大类"
						align="center"
						min-width="180">
					</el-table-column>
					<el-table-column
						prop="smallcategory"
						v-if="bigcategoryview === 1"
						label="店铺级小类"
						align="center"
						min-width="180">
					</el-table-column>
					<el-table-column
						prop="disabledflag"
						label="启用状态"
						align="center"
						min-width="100">
						<template slot-scope="scope">
							<span v-if="scope.row.disabledflag">停用</span>
							<span v-else>启用</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
        </div>
		<div v-else style="text-align:left;height:100%">
			自动绑定该集团下所有销售店铺的私密商品、使用过程中如果店铺有新增私密商品，
			也会自动和客户产生绑定关系。
		</div>
        <div class="binding-foot">
            <el-button class="fx-big-btn" size='small' @click="cancelClick">取消</el-button>
            <el-button class="fx-big-btn" type="primary"  size='small' @click="saveClick">确认</el-button>
        </div>
	</div>
</template>
<script>
export default {
	name: 'addModal',
	props: {
		addModal: Boolean,
		customerName: String,
		customerid: String
	},
	data () {
		return {
			productQueryType: 1,
			privateproductflag: 0,
			bcId: '0',
			scId: '0',
			bc: [],
			sc: [],
			shopid: '',
			shopList: [],
			productName: '',
			tableData: [],
			total: 0,
			page: {
				number: 1,
				size: 20
			},
			tableHeight: '100%',
			bigcategoryview: 0,
			privateproductFlag: -1,
			disabledflag: -1,
			pcode: '',
			matchcode: '',
			tableSelectUtils: this.$fxUtils.tableSelectUtils({
				key: 'id'
			}),
			shopNameList: [],
			shopIds: []
		}
	},
	watch: {
		addModal: {
			handler (val) {
				if (val) {
					this.productName = ''
					this.privateproductFlag = -1
					this.disabledflag = -1
					this.pcode = ''
					this.matchcode = ''
					this.shopIds = []
					this.getShop()
					this.getBigCategory()
					this.getShopList()
					if (this.bigcategoryview === 1) {
						this.getSmalCategory()
					}
				}
			},
			immediate: true
		}
	},
	created () {
		this.checkSmallCategory()
	},
	computed: {
		ids () {
			return this.tableSelectUtils.getSelectRows()
		}
	},
	methods: {
		handleSelectionChange (data) {
			this.tableSelectUtils.selectToggle(this.tableData, data)
			this.$nextTick(() => {
				this.tableSelectUtils.setTableDefaultSelect(this.ids, this.$refs.multipleTable1)
			})
		},
		handleSelectionChange1 (data) {
			this.tableSelectUtils.selectToggle(this.ids, data)
			this.$nextTick(() => {
				this.tableSelectUtils.setTableDefaultSelect(this.tableData, this.$refs.multipleTable)
			})
		},
		// 是否开启小类
		checkSmallCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
			}).then(res => {
				this.bigcategoryview = res.bigcategoryview
			})
		},
		bcChange () {
			this.scId = '0'
			if (this.bigcategoryview === 1) {
				this.getSmalCategory()
			}
		},
		getBigCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getBigCategory`
			}).then(res => {
				if (res.result) {
					this.bc = res.data
				}
			})
		},
		getSmalCategory () {
			let params = {
				pid: this.bcId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getSmalCategory`,
				data: params
			}).then(res => {
				if (res.result) {
					this.sc = res.data
				}
			})
		},
		cancelClick () {
			this.$emit('cancel', false)
		},
		saveClick () {
			let a = this.ids
			if (this.privateproductflag === 0) {
				if (a.length === 0) {
					this.$message.error('请选择商品！')
					return false
				}
			}
			let logArr = this.ids.map(e => {
				return `【”私密商品：${e.name}”，“销售门店：${e.shopname}”】`
			})
			let changeData = {
				info: `“客户：${this.customerName}”新增绑定` + logArr.join(',')
			}
			const logger = this.$fxLogger.createInfo('custom.custom-else.info', changeData)
			let params = {
				customerid: this.customerid,
				productShopDTOS: a,
				privateproductflag: this.privateproductflag
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/saveproductbycustomer`,
				data: params,
				logger
			}).then(res => {
				if (res.resultFlag) {
					this.$message.success('保存成功！')
					this.tableSelectUtils.clear()
					this.tableReload()
				} else {
					this.$message.error(res.message)
				}
			})
		},
		search () {
			this.page = {
				number: 1,
				size: 20
			}
			this.tableReload()
		},
		clear () {
			this.productName = ''
			this.pcode = ''
			this.matchcode = ''
			this.bcId = '0'
			this.scId = '0'
			this.privateproductFlag = -1
			this.disabledflag = -1
			this.shopIds = []
			this.search()
		},
		getShop () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/getAllShopBySyscodeId`
			}).then(res => {
				if (res.result) {
					this.shopList = res.data
					if (res.data.length > 0) {
						this.shopid = res.data[0].id
					}
					this.$nextTick(() => {
						this.tableReload()
					})
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		tableReload () {
			if (this.shopid === '') {
				// this.$message.error('请选择销售门店')
				return false
			}
			let params = {
				shopid: this.shopid,
				bigTypeCategory: this.bcId,
				smallTypeCategory: this.scId,
				productName: this.productName,
				customerid: this.customerid,
				page: this.page.number,
				size: this.page.size,
				privateproductflag: this.privateproductFlag,
				disabledflag: this.disabledflag,
				productCode: this.pcode,
				matchCode: this.matchcode,
				shopIds: this.shopIds
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/customer/unrelproduct`,
				data: params
			}).then(res => {
				res.recordList = res.recordList ? res.recordList : []
				res.recordList.forEach(item => {
					item.id = item.productid + item.shopid
				})
				this.tableData = res.recordList
				this.$nextTick(() => {
					this.tableSelectUtils.setTableDefaultSelect(this.tableData, this.$refs.multipleTable)
				})
				this.productQueryType = res.crp.productQueryType
				this.total = res.recordCount
			})
		},
		handleSizeChange (val) {
			this.page.size = val
			this.tableReload()
		},
		handleCurrentChange (val) {
			this.page.number = val
			this.tableReload()
		},
		selectInit (row) {
			if (this.productQueryType === 0) {
				if (row.hiddenflag) {
					return true
				} else {
					return false
				}
			} else {
				return true
			}
		},
		getShopList () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/selectShopList`
			}).then(res => {
				this.shopNameList = res
			})
		}
	}
}
</script>
<style lang="stylus" scoped>

.binding-body{
	display: flex;
	width :100%;
	flex-direction: column;
	height :600px;
	position :relative;
    border-radius :0px 0px 10px 10px;
	.cusApro-add-search {
		width:100%;
		line-height :40px;
        border-bottom :1px solid #f1f1f1;
		display:flex;
	}
	.search-box{
		display:flex;
		flex-wrap:wrap;
		.input-box{
			margin-bottom:10px
			&>span {
				width: 85px;
				display: inline-block;
				text-align: right;
			}
			.name-input {
				width: 150px;
				margin-right: 10px;
			}
			.select-box{
				width:150px;
				margin-right:10px;
			}
		}
	}
	.input-box-btn{
		width: 150px;
		flex-shrink: 0
	}
	.table-container{
		display: flex;
		box-sizing: border-box
		height:calc(100% - 200px);
	}
    .table-box{
		height: 100%;
		width: calc(50% - 10px)
		.page-box{
			margin-top:10px
			text-align :center
		}
    }
	.select-title{
		line-height: 30px;
		text-align: left
	}
	.grid-content{
		height: calc(100% - 70px) !important
	}
    .btn-box{
        width :90%;
        padding :10px;
        text-align :left
    }
    .binding-foot{
        position: relative;
        height :40px;
		margin-top:10px;
        margin-bottom :10px;
        width :100%
        .btn{
            width :35%;
			margin-left:30px;
        }
    }
}

</style>
<style lang="stylus">
.binding-body {
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
